import ForgotPasswordPopup from "./ForgotPasswordPopup";
import LoginPopup from "./LoginPopup";
import SetPasswordPopup from "./SetPasswordPopup";
import { SentryRoute } from "../../core/SentryRoute";
import { Redirect, Switch } from 'react-router-dom';
import { SetPasswordModes } from "./LoginTypes";
import "./Login.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoginPage = () => {
  return /*#__PURE__*/_jsx("div", {
    className: "LoginPage",
    "data-sentry-component": "LoginPage",
    "data-sentry-source-file": "LoginPage.tsx",
    children: /*#__PURE__*/_jsxs(Switch, {
      "data-sentry-element": "Switch",
      "data-sentry-source-file": "LoginPage.tsx",
      "data-sentry-element": "Switch",
      children: [/*#__PURE__*/_jsx(SentryRoute, {
        exact: true,
        path: "/login",
        component: LoginPopup,
        "data-sentry-element": "SentryRoute",
        "data-sentry-source-file": "LoginPage.tsx",
        "data-sentry-element": "SentryRoute"
      }), /*#__PURE__*/_jsx(SentryRoute, {
        exact: true,
        path: "/login/set-password",
        render: props => /*#__PURE__*/_jsx(SetPasswordPopup, {
          ...props,
          mode: SetPasswordModes.Recover
        }),
        "data-sentry-element": "SentryRoute",
        "data-sentry-source-file": "LoginPage.tsx",
        "data-sentry-element": "SentryRoute"
      }), /*#__PURE__*/_jsx(SentryRoute, {
        exact: true,
        path: "/login/activate",
        render: props => /*#__PURE__*/_jsx(SetPasswordPopup, {
          ...props,
          mode: SetPasswordModes.Register
        }),
        "data-sentry-element": "SentryRoute",
        "data-sentry-source-file": "LoginPage.tsx",
        "data-sentry-element": "SentryRoute"
      }), /*#__PURE__*/_jsx(SentryRoute, {
        exact: true,
        path: "/login/forgot-password",
        component: ForgotPasswordPopup,
        "data-sentry-element": "SentryRoute",
        "data-sentry-source-file": "LoginPage.tsx",
        "data-sentry-element": "SentryRoute"
      }), /*#__PURE__*/_jsx(SentryRoute, {
        render: () => /*#__PURE__*/_jsx(Redirect, {
          to: "/not-found"
        }),
        "data-sentry-element": "SentryRoute",
        "data-sentry-source-file": "LoginPage.tsx",
        "data-sentry-element": "SentryRoute"
      })]
    })
  });
};
export default LoginPage;